import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings/hexColors'

export const StructuredSearchResultPrimaryInfoStyled = styled.span({
  fontSize: '1.2rem',
  display: 'block',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
})

export const StructuredSearchResultSecondaryInfoStyled = styled.span({
  color: hexColors.dimGrey,
  display: 'block',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  fontSize: '1.0rem',
})

export const StructuredSearchResultInfoHeaderStyled = styled.div({
  borderBottom: `1px solid ${hexColors.gainsboro}`,
  textAlign: 'right',
  padding: '0.25rem 1rem',
})

export const StructuredSearchFixedOddsLabelStyled = styled.span({
  fontSize: '1.2rem',
  fontWeight: 'bold',
  color: hexColors.scooter,
})

export const DriverStyled = styled(StructuredSearchResultSecondaryInfoStyled)({
  marginRight: '3px',
  display: 'inline',
})

export const StructuredSearchResultStyled = styled.div({
  fontSize: '1.2rem',
  backgroundColor: hexColors.white,
  padding: '0.5rem 0.75rem',
  borderBottom: `1px solid ${hexColors.gainsboro}`,
})

export const NoResultsStyled = styled.div({
  fontSize: '1.8rem',
  transform: 'translate(0%, 90%)',
  textAlign: 'center',
})
